module.exports = __webpack_public_path__ + "files/da397e4bfff4f5d195b4cf361568a3aa.svg";